/* eslint-disable unicorn/filename-case -- TODO rename later */
export enum ModelActionType {
  EXTRACT = "extract",
  ARCHIVE = "archive",
  RENAME = "rename",
  SHARE = "share",
}
